<script>
  import { translator } from "../../store";
  import Drawer from "../Drawer/index.svelte";
  import Button from "../Button/index.svelte";
  import { PPPlaceholder } from "../../helpers/utils.svelte";

  export let reservationDetails;
  export let propertyDetails;
  export let onClose;
</script>

<Drawer visible={reservationDetails} {onClose}>
  <div class="card-body">
    <div class="d-flex align-items-center">
      <img src={reservationDetails?.pp_file?.url || PPPlaceholder} alt="" class="rounded profile-img me-4">
      <div>
        <h4 class="mb-0">{reservationDetails.guest_name}</h4>
        <h6 class="text-primary">{reservationDetails.check_in.split(' ')[0]} - {reservationDetails.check_out.split(' ')[0]}</h6>
      </div>
    </div>
    <ul class="user-info-list">
      <li>
        <i class="fas fa-map-marker-alt"></i>
        <span class="w-75">{propertyDetails.address}</span>
      </li>
    </ul>
    <div class="row mt-4 pt-3">
      <Button onClick={onClose} colorCls="btn-dark light">
        {translator("Detayları gizle")}
      </Button>
    </div>
  </div>
</Drawer>
